/* Silo Digital — sticky article reading-progress bar. */
(function () {
  class SdArticleProgress extends HTMLElement {
    connectedCallback() {
      this.fill = this.querySelector('.sd-progress__fill');
      this.target = document.querySelector('.sd-article__content') || document.querySelector('.article-content');
      if (!this.target) { return; }
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }
    onScroll() {
      var rect = this.target.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var total = rect.height - vh;
      var scrolled = Math.min(Math.max(-rect.top, 0), total > 0 ? total : 0);
      var pct = total > 0 ? (scrolled / total) * 100 : 0;
      if (this.fill) { this.fill.style.width = pct + '%'; }
      this.classList.toggle('is-visible', rect.top < -40);
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }
  if (!customElements.get('sd-article-progress')) {
    customElements.define('sd-article-progress', SdArticleProgress);
  }
})();
